import { toDate, format } from 'date-fns';

// types
import { YearMonthSelectorProps } from './types';

// componentns
import Select from '../select/select';
import { SelectSize, OnSelectChange } from '../select/types';
import Navbar from './navbar';

// styles
import styles from './rangepicker.module.css';

export default function YearMonthSelector({
  date,
  localeUtils,
  onChange,
  years,
}: YearMonthSelectorProps): React.JSX.Element {
  const months = localeUtils.getMonths();

  const monthsList = months.map((month, index) => ({
    name: month,
    value: index,
  }));

  const yearsList = years.map((year: number) => ({
    name: year.toString(),
    value: year.toString(),
  }));

  const onNextClick = () => {
    const nextMonth = new Date(
      new Date(date).setMonth(new Date(date).getMonth() + 1),
    );

    onChange(
      toDate(new Date(new Date(nextMonth).getFullYear(), nextMonth.getMonth())),
    );
  };

  const onPreviousClick = () => {
    const prevMonth = new Date(
      new Date(date).setMonth(new Date(date).getMonth() - 1),
    );

    onChange(
      toDate(new Date(new Date(prevMonth).getFullYear(), prevMonth.getMonth())),
    );
  };

  const handleChangeSelectMonth = (e: OnSelectChange) => {
    const { value } = e.target;

    if (value) {
      // forced conversion of type `string | number` to `Number()` for `new Date`
      // in data flow for this component the field `value` can be number only
      const month = Number(value);

      onChange(toDate(new Date(date.getFullYear(), month)));
    }
  };

  const handleChangeSelectYear = (e: OnSelectChange) => {
    const { value } = e.target;

    if (value) {
      // forced conversion of type `string | number` to `Number()` for `new Date`
      // in data flow for this component the field `value` can be number only
      const year = Number(value);
      onChange(toDate(new Date(year, date.getMonth())));
    }
  };

  return (
    <div className={styles.caption}>
      <Select
        name="month-select"
        className={styles.captionMonthSelect}
        list={monthsList.map((item) => ({
          name: item.name,
          value: item.value.toString(),
        }))}
        onChange={handleChangeSelectMonth}
        size={SelectSize.SMALL}
        value={date.getMonth().toString()}
      />

      <Select
        name="year-select"
        className={styles.captionYearSelect}
        list={yearsList}
        onChange={handleChangeSelectYear}
        size={SelectSize.SMALL}
        value={format(date, 'yyyy')}
        yearSelector
      />
      <Navbar
        className={styles.navbar}
        onNextClick={onNextClick}
        onPreviousClick={onPreviousClick}
      />
    </div>
  );
}
